import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../common/components/Modal/modal';
import { Formik, Form, useFormik } from 'formik';
import CommonInput from '../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../components/Dashboard-res/CommonComponent/CommonSelect';
import initialImg from '../../images/icons/upload_new.svg';
import uploadIcon from '../../images/icons/CompanyGrading/download.svg';
import {
  addCompany,
  getIndustryPresignedUrl,
  UploadFileToS3
} from '../../common/constants/api';
import { object, string, array } from 'yup';
import * as _ from 'lodash';
import PopUp from '../../common/components/PopUp/PopUp';
import Toast from '../../common/components/Toast/Toast';
import GlobalUploadComp from '../../common/components/GlobalUploadComp/GlobalUploadComp';
import ShowGetImage from '../../common/components/ShowGetImage/ShowGetImage';
import { DeveloperDataContext } from '../../../../lems-ui/src/pages/app';

const AddCompany = ({
  showModal,
  setShowModal,
  setAddCompany,
  industryOptions,
  companyTypeOptions,
  segmentOptions
}) => {
  const [doc, setDoc] = useState('');
  const [dontClose, setDontClose] = useState(true);
  const [showOtherCompanyTypeField, setShowOtherCompanyTypeField] = useState(
    false
  );
  const [showOtherIndustryField, setShowOtherIndustryField] = useState(false);
  const [showOtherSegmentField, setShowOtherSegmentField] = useState(false);

  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);

  const context = useContext(DeveloperDataContext);

  const validationSchema = object().shape({
    company_name: string().required('Required'),
    file: array().required('Required')
  });

  const formik = useFormik({
    initialValues: {
      company_name: '',
      industry: {
        id: 1,
        value: '',
        label: 'Industry'
      },
      company_type: {
        value: '',
        label: 'Company Type'
      },
      segment: {
        value: '',
        label: 'Segment'
      },
      file: [],
      imgUrl: [],
      onLoading: true
    },
    validationSchema: validationSchema,
    onSubmit: values => {}
  });

  const commonFormikFunction = name => {
    if (!name || typeof name != 'string') return;

    return {
      name: name,
      onBlur: formik.handleBlur,
      value: formik.values[name],
      error: formik.touched[name] && formik.errors[name],
      errorMsg: formik.errors[name],
      touched: formik.touched[name],
      setFieldValue: formik.setFieldValue,
      stylesContainer: { maxWidth: '100%' }
    };
  };

  const modalStyle = {
    maxWidth: '600px',
    minWidth: '250px'
  };

  const commonInputDiv = 'md:w-6/12 w-full px-3 py-1 my-2';

  const selectBoxCommonStyle = isDisabled => {
    return {
      dropdownStyle: {
        top: '52px',
        fontSize: '16px'
      },
      stylesContainer: {
        height: '52px',
        ...(isDisabled ? { opacity: '0.5' } : {})
      },
      styleText: {
        fontSize: '14px',
        padding: '0 20px'
      }
    };
  };

  const industryOnChange = e => {
    formik.setFieldValue('industry', {
      id: e.id,
      value: e.value,
      label: e.label
    });
    if (e.value != 'Others') return;
    setShowOtherIndustryField(true);
  };

  const segmentOnChange = e => {
    formik.setFieldValue('segment', {
      value: e.value,
      label: e.label
    });
    if (e.value != 'Others') return;
    setShowOtherSegmentField(true);
  };

  const companyTypeOnChange = e => {
    formik.setFieldValue('company_type', {
      value: e.value,
      label: e.label
    });
    if (e.value != 'Others') return;
    setShowOtherCompanyTypeField(true);
  };

  const selectFiledCommonFormikFunction = name => {
    if (!name || typeof name != 'string') return;

    return {
      name: name,
      error:
        formik.touched[name] && _.get(formik.errors, `${name}.value`, false),
      touched: formik.touched[name],
      value: formik.values[name]
    };
  };

  const handleCompanyName = e => {
    let patt = new RegExp(/[^a-z,^A-Z,^0-9,\s]/g);
    let errors = e.target.value.toString().match(patt);
    if (errors) return;
    formik.setFieldValue('company_name', e.target.value);
  };

  const handleSubmition = url => {
    formik.validateForm().then(res => {
      if (Object.keys(res).length != 0) {
        formik.handleSubmit();
      } else {
        createCompany(url);
      }
    });
  };

  const createCompany = url => {
    setAddCompany(true);
    setShowModal(false);
    setShow(true);
    setType('loading');
    setText('Creating Company please wait...');

    let body = {
      industryId: formik.values?.industry?.id,
      companyName: formik.values.company_name,
      typeOfCompany: formik.values?.company_type?.value,
      industryName: formik.values?.industry?.value,
      docUrl: url,
      segmentName: formik.values?.segment?.value
    };

    addCompany(body)
      .then(res => {
        if (res.error) throw new Error(res);
        setShow(false);
        setAddCompany(false);
        Toast(
          'success',
          'Company has been added successfully',
          '3000',
          'top-center'
        );
        context.setAppData({
          ...context.appData,
          companyReload: !context.appData.companyReload,
          shouldUpload: false
        });
      })
      .catch(error => {
        setShow(false);
        setAddCompany(false);
      });
  };

  return (
    <Formik
      initialValues={formik.initialValues}
      onSubmit={(values, actions) => {}}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        setValues
      }) => {
        async function fileUpload() {
          setType('loading');
          setText('Uploading the File Please Wait...');
          setShow(true);
          setDontClose(true);
          await getIndustryPresignedUrl()
            .then(res => {
              UploadFileToS3(res?.presignedUrl, values?.file[0][0], {
                'x-amz-acl': 'public-read'
              }).then(() => {
                handleSubmition(res?.url);
                setType('success');
                setText('Uploaded the File successfully.');
                setShow(true);
                setDontClose(false);
              });
            })
            .catch(err => {
              setShow(false);
            });
        }

        return (
          <Form>
            <div className="w-full">
              <Modal
                show={showModal}
                setShow={setShowModal}
                title={
                  <span className="font-bold font-roboto text-xl text-black-0">
                    Add New Company
                  </span>
                }
                styleContainer={modalStyle}
              >
                <hr
                  className="border-grey-100 w-full"
                  style={{ borderWidth: 'thin' }}
                />
                <div
                  className="w-full overflow-auto"
                  style={{ maxHeight: '80vh', overflow: 'auto' }}
                >
                  <div className="mt-5 ">
                    <div className="w-full px-3 py-1 my-2">
                      <CommonInput
                        legendName="Company Name"
                        {...commonFormikFunction('company_name')}
                        onChange={handleCompanyName}
                      />
                    </div>
                  </div>
                  <div className="pr-5 mt-6">
                    <p className="ml-4">Upload company logo</p>
                    <div className=" w-full ml-4 pr-2 mt-2">
                      <div className="flex flex-col justify-start  md:flex-wrap  ">
                        {doc ? (
                          <div
                            className=" mt-2 mr-auto "
                            style={{
                              width: 'fit-content'
                            }}
                          >
                            <ShowGetImage img={doc} />
                          </div>
                        ) : (
                          <React.Fragment>
                            <div
                              className="bg-white  rounded-lg border border-navy-200 md:border-none py-7  px-5 md:py-0 md:pl-0 md:pr-0"
                              style={{
                                width: 'fit-content'
                              }}
                            >
                              <GlobalUploadComp
                                data={values}
                                imgIndex={0}
                                errors={errors}
                                touched={touched}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                setFieldValue={setFieldValue}
                                setFieldTouched={setFieldTouched}
                                setFieldError={setFieldError}
                                initialImg={initialImg}
                                subInst="Click here to upload File"
                                subtext="CHOOSE FILE"
                                isPdf={false}
                              >
                                <div className="md:hidden flex items-center flex-col">
                                  <img src={uploadIcon} alt="" />
                                  <p className="text-black-1011 text-sm mt-1 font-light">
                                    Upload File
                                  </p>
                                </div>
                                <div className="hidden md:block mt-3 items-center justify-center flex-col">
                                  <div className="flex justify-center items-center mt-3">
                                    <img src={uploadIcon} alt="" />
                                  </div>
                                  <p className="text-black-1011 mt-9  font-roboto font-normal text-xs mx-auto">
                                    Click here to upload File
                                  </p>
                                  <p className="text-black-700 font-roboto font-bold text-sm mt-5 ">
                                    CHOOSE FILE
                                  </p>
                                </div>
                              </GlobalUploadComp>
                            </div>
                            <p className="block md:hidden md:max-w-full font-roboto font-normal text-xs text-black-50 break-word mt-0.5">
                              (upload file upto 20MB in jpeg, jpg and png
                              format)
                            </p>
                            {(errors?.file || errors?.imgUrl) && (
                              <p className="text-xs text-red-300 mt-1">
                                {errors?.file || errors?.imgUrl}
                              </p>
                            )}
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="md:flex ">
                    <div className={`${commonInputDiv}`}>
                      <CommonSelect
                        onChange={industryOnChange}
                        options={industryOptions}
                        {...selectBoxCommonStyle(false)}
                        {...selectFiledCommonFormikFunction('industry')}
                      />
                    </div>
                    <div className={`${commonInputDiv}`}>
                      <CommonSelect
                        onChange={companyTypeOnChange}
                        options={companyTypeOptions}
                        {...selectBoxCommonStyle(false)}
                        {...selectFiledCommonFormikFunction('company_type')}
                      />
                    </div>
                  </div>
                  <div className="md:flex ">
                    <div className={`${commonInputDiv}`}>
                      <CommonSelect
                        onChange={segmentOnChange}
                        options={segmentOptions}
                        {...selectBoxCommonStyle(false)}
                        {...selectFiledCommonFormikFunction('segment')}
                      />
                    </div>
                  </div>
                  <div className="w-full mt-8">
                    <button
                      type="button"
                      onClick={() => {
                        fileUpload();
                      }}
                      className="submitButton text-16 w-56 h-12 font-medium  font-roboto"
                    >
                      Create Company
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
            <PopUp type={type} text={text} show={show} setShow={setShow} />
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddCompany;
